import type { TPermissionMapping, TUpPermission } from '../../pages/users/type';

import * as PERMISSION_CONFIG from '../../mappings/permission';

type TPermissionConfig = {
  [key: string]: {
    [key: string]: TPermissionMapping[] | [];
  };
};

export const getPermission = (permissionArr: TUpPermission[]) => {
  let results: TPermissionMapping[] = [];
  permissionArr.forEach((_permission) => {
    const name = _permission.group;
    const configuration = PERMISSION_CONFIG as unknown as TPermissionConfig;
    let type = _permission.name;
    let result: TPermissionMapping[] = [];
    if (configuration[name]) {
      type = type.trim().toLowerCase().replace(' ', '_');
      const configName = configuration[name];
      const isIncludedKey = Object.keys(configName).includes(type);
      if (isIncludedKey) {
        result = configuration[name][type];
        results = [...results, ...result];
      }
    }
  });
  return results;
};
